import "./assets/main.css";
import "./assets/tailwind.css";

import React from "react";
import ReactDOM from 'react-dom/client'

import { Provider } from "react-redux";

import App from "./App.jsx";
import { store } from "./redux/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
        <App />
    </Provider>
);
